import React, { useContext } from 'react';
import { connect } from 'react-redux';

import { ProjectsContext } from '../../../providers/ProjectsProvider';
import type { AuthenticationConfig } from '../../../state-management/states';
import RoleAssignmentComponent from './Base';

const ProjectLevelAssignment: React.FC<{
    token: string;
    authConfig: AuthenticationConfig;
}> = ({
    token,
    authConfig,
}) => {
    const { state: projectState } = useContext(ProjectsContext);

    return (
        <RoleAssignmentComponent
            token={token}
            level="PROJECT"
            projectId={projectState?.currentProjectId}
            identityUrl={authConfig.identityAPIUrl} />
    );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default connect((state: any) => ({
    token: state.auth.authToken,
    authConfig: state.config.paths ? state.config.paths.authConfig : {},
}))(ProjectLevelAssignment);
